(() => {
  const mountProductCarousel = () => {
    if (!customElements.get('products-carousel')) {
      customElements.define(
        'products-carousel',
        class ProductsCarousel extends HTMLElement {
          constructor() {
            super();
            this.swiper = null;
            this.handleResize = this.handleResize.bind(this);
          }

          connectedCallback() {
            if (document.readyState != 'complete' && this.dataset.lazyLoadAssets != 'true') {
              document.addEventListener('DOMContentLoaded', () => this.initOrDestroyCarousel());
            } else {
              this.initOrDestroyCarousel();
            }
            window.addEventListener('resize', this.handleResize);
          }

          disconnectedCallback() {
            window.removeEventListener('resize', this.handleResize);
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
          }

          handleResize() {
            this.initOrDestroyCarousel();
            this.updateSwiperCentering(this.swiper);
          }

          updateSwiperCentering(swiperInstance) {
            if (!swiperInstance)
              return
            const wrapper = swiperInstance.wrapperEl;
            const container = swiperInstance.el;

            const slidesWidth = wrapper.scrollWidth;
            const containerWidth = container.clientWidth;

            if (slidesWidth >= containerWidth) {
              this.querySelector('.swiper-container').classList.remove('center-slides');
            } else {
              this.querySelector('.swiper-container').classList.add('center-slides');
            }

            swiperInstance.update(); // Recalculate layout
          }

          initOrDestroyCarousel() {
            const swiperContainer = this.querySelector('.swiper-container');

            if (!swiperContainer) {
              // console.error('Swiper container not found in popular-categories component.');
              return;
            }

            // Check if the swiper instance already exists
            if (!this.swiper) {
              // INIT
              const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
              const bannerInterval = swiperWrapper.getAttribute('data-interval') || 5000;
              const bannerSpeed = swiperWrapper.getAttribute('data-transition') || 1500;

              this.swiper = new Swiper(swiperContainer, {
                slidesPerView: 2,
                spaceBetween: 10,
                loop: false,
                autoplay: {
                  delay: bannerInterval,
                  disableOnInteraction: false,
                },
                speed: bannerSpeed,
                breakpoints: {
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                  },
                  1600: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                  },
                  2000: {
                    slidesPerView: 6,
                    spaceBetween: 20,
                  }
                }
              });

              this.updateSwiperCentering(this.swiper);
            }
          }
        }
      );
    }
  }
  if ('requestIdleCallback' in window) requestIdleCallback(mountProductCarousel);
  else setTimeout(mountProductCarousel, 200);
})();